import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useLazyGetConfluenceSummaryQuery } from '../services/rtkApi';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { LocalLoader } from '@klp/design/Loader';
import ReactHtmlParser from 'react-html-parser';
import { contextSelectors } from '@klp/contextSelector';
import { sanitizeHtmlContent } from '@forvalter/utils/sanitizeHtmlContent';

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(2),
        backgroundColor: '#eae6ff',
        fontSize: '1rem',
    },
}));

export default function ForvaltningsplanSummary() {
    const classes = useStyles();

    const { selectedContext } = useSelector(contextSelectors);

    const [
        getConfluenceSummary,
        {
            data: confluenceSummaryData,
            isLoading: confluenceSummaryLoading,
            isFetching: confluenceSummaryFetching,
        },
    ] = useLazyGetConfluenceSummaryQuery();

    useEffect(() => {
        if (!selectedContext?.id) return;

        getConfluenceSummary({
            byggNummer: selectedContext?.id,
            aar: new Date().getFullYear(),
        });
    }, [getConfluenceSummary, selectedContext]);

    if (!selectedContext) return null;

    return (
        <LocalLoader
            isLoading={confluenceSummaryLoading || confluenceSummaryFetching}
        >
            {confluenceSummaryData?.body && (
                <Paper className={classes.card} variant="outlined">
                    {ReactHtmlParser(
                        sanitizeHtmlContent(confluenceSummaryData.body),
                    )}
                </Paper>
            )}
        </LocalLoader>
    );
}
